<template>
   <form>
      <div class="form-group">
         <div class="row" v-if="errorMssg != null">
            <div class="col-md-12 error_text">
               <p style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</p>
            </div>
         </div>

         <div class="row">
            <div class="col-sm-6 form-col rg-form">
               <label for="constitution_date" class="form-label">Fecha de constitución de la empresa *</label>
               <set-date id="constitution_date" @set="function(d){model.constitution_date = d}"></set-date>
            </div>
            <div class="col-sm-6 form-col rg-form">
               <label for="state_id" class="form-label">Estado de nacimiento del representante legal</label>
               <select id="state_id" v-model="model.state_id" class="form-control" required>
                  <option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</option>
               </select>
            </div>
            <div class="col-sm-12 form-col rg-form">
               <label for="bank_id" class="form-label">Banco registrado para la realización de operaciones *</label>
               <select id="bank_id" v-model="model.bank_id" class="form-control" required >
                  <option v-for="bank in banks" :value="bank.id" :key="bank.id">{{ bank.name }}</option>
               </select>
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import SetDate from "@components/shared/SetDate";
export default {
   name: "SLRPerson0And4",
   components: {SetDate},
   props: {
      states: {
         type: Array,
         required: true,
      },
      banks: {
         type: Array,
         required: true,
      },
   },
   data() {
      return {
         model: {
            constitution_date: null,
            state_id: null,
            bank_id: null,
         },
         errorMssg: null,
      }
   },
   methods: {
      checkForm(){
         this.errorMssg = null
         return this.validateFields();
      },
      getPayload(){
         return {
            constitution_date: this.model.constitution_date,
            birth_state: this.model.state_id,
            bank_id: this.model.bank_id
         }
      },
      validateFields(){
         let missing = []
         if(this.model.constitution_date == null){
            missing.push('Fecha de constitución de la empresa')
         }
         if(this.model.state_id == null){
            missing.push('Estado de nacimiento del representante legal')
         }
         if(this.model.bank_id == null){
            missing.push('Banco registrado para la realización de operaciones')
         }
         if(missing.length > 0){
            this.errorMssg = `Por favor verifica los siguientes campos: ${missing.join(', ')}`
            return false
         }
         return true
      },
   },
}
</script>